import type { RateOrInherit } from '@finsim/model';
import type { TFunction } from 'i18next';
import { formatPercent } from '../../../shared/lib/format';
import type { Locale } from '../../../shared/lib/locale';

/** Short text for a rate: "3 %", "CPI + 2 %", "≈ 6 % ± 15 %", "Default". */
export function describeRate(
  spec: RateOrInherit,
  t: TFunction,
  locale: Locale,
  inheritLabel?: string,
): string {
  const pct = (v: number): string => formatPercent(v, locale, 2).replace('-', '−');
  switch (spec.kind) {
    case 'fixed':
      return pct(spec.rate);
    case 'cpiRelative':
      return t('rate.describeCpi', {
        offset: `${spec.offset >= 0 ? '+' : ''}${pct(spec.offset)}`,
      });
    case 'distribution':
      return t('rate.describeDistribution', { mean: pct(spec.mean), vol: pct(spec.volatility) });
    case 'inherit':
      return inheritLabel ?? t('rate.kinds.inherit');
  }
}
